import defaultImg from "assets/icons/default_product_picture.svg";
import { ERequestType, Product } from "generated/graphql";
import { BoxIcon, PriceIcon } from "icons";
import React from "react";
import { truncateMessage } from "utils";
import { InputCounter } from "../MainStyles";
import {
  CardImageProduct,
  ContainerCounterProduct,
  DescriptionProduct,
  DescriptionProductDetails,
  DetailsProduct,
  FillImageProduct,
  FooterProduct,
  ImageProduct,
  ItemFooterProduct,
  NameProduct,
  ValueItemFooterProduct,
} from "./CatalogStyles";

interface IItemCatalog {
  product: Product;
  counter?: number;
  requestType: ERequestType;
}
export default function ItemDetailsStop({ product, counter, requestType }: IItemCatalog) {
  return (
    <>
      <ImageProduct>
        <CardImageProduct>
          <FillImageProduct src={product?.photoUrl || defaultImg} alt="image produit" />
        </CardImageProduct>
      </ImageProduct>
      <DetailsProduct>
        <NameProduct>{truncateMessage(product?.name, 20)}</NameProduct>
        <DescriptionProduct>
          <DescriptionProductDetails>{truncateMessage(product?.description, 20)}</DescriptionProductDetails>
          {requestType !== ERequestType.Tr && (
            <ContainerCounterProduct>
              <InputCounter value={counter} disabled />
            </ContainerCounterProduct>
          )}
        </DescriptionProduct>
        <FooterProduct>
          <ItemFooterProduct>
            <span>
              <BoxIcon color="#f69833" height={20} width={20} />
            </span>
            <ValueItemFooterProduct>{product?.weight}</ValueItemFooterProduct>
          </ItemFooterProduct>
          <ItemFooterProduct>
            <span>
              <PriceIcon color="#f69833" height={20} width={20} />
            </span>
            <ValueItemFooterProduct>{product?.value} XOF</ValueItemFooterProduct>
          </ItemFooterProduct>
          <ItemFooterProduct>
            <ValueItemFooterProduct>{product?.reference?.length ? product?.reference : "N/A"}</ValueItemFooterProduct>
          </ItemFooterProduct>
        </FooterProduct>
      </DetailsProduct>
    </>
  );
}
